// Parses HigherGov's `opp_cat` field into two separate, display-ready
// dimensions. Confirmed via a live API sample — opp_cat combines scope and
// stage into one string, e.g. "Federal Contract Opportunity",
// "SLED Contract Opportunity", "Federal Forecast Opportunity",
// "SLED Forecast Opportunity", "Federal Grant Opportunity". "SLED" is the
// standard government-contracting term for State/Local/Education/District.
export const HG_SCOPE_CONFIG = {
  Federal: { label: 'Federal', cls: 'bg-blue-100 text-blue-700 border border-blue-200' },
  SLED:    { label: 'State/Local', cls: 'bg-purple-100 text-purple-700 border border-purple-200' },
};

export const HG_STAGE_CONFIG = {
  Opportunity: { label: 'Live', cls: 'bg-emerald-100 text-emerald-700 border border-emerald-200' },
  Forecast:    { label: 'Forecast', cls: 'bg-amber-100 text-amber-700 border border-amber-200' },
  Grant:       { label: 'Grant', cls: 'bg-teal-100 text-teal-700 border border-teal-200' },
};

/** @returns {{scope: 'Federal'|'SLED'|null, stage: 'Opportunity'|'Forecast'|'Grant'|null}} */
export function parseHgOppCat(oppCat) {
  if (!oppCat || typeof oppCat !== 'string') return { scope: null, stage: null };
  const scope = oppCat.includes('Federal') ? 'Federal' : oppCat.includes('SLED') ? 'SLED' : null;
  const stage = oppCat.includes('Forecast') ? 'Forecast' : oppCat.includes('Grant') ? 'Grant' : oppCat.includes('Opportunity') ? 'Opportunity' : null;
  return { scope, stage };
}
